<template>
  <div id="footer" class="no-print">
    <footer class="pl-3 pr-3" role="contentinfo" aria-label="網站頁尾">
      <div class="row">
        <!-- 左方內容 -->
        <div class="col-12 col-sm-6 spanfs">
          © 2019 高雄大學 National University of Kaohsiung
          <br />81148 高雄市楠梓區高雄大學路700號 <br />700, Kaohsiung
          University Rd., Nanzih District, Kaohsiung 811, Taiwan, R.O.C.
          <br />高大總機:886-7-5919000；出納組分機8650-8654；傳真號碼:886-7-5919279
          <br />維護廠商:中冠資訊股份有限公司
        </div>
        <!-- 右方內容 -->
        <div class=" col-12 col-sm-6 spanfs">
          <a
            style="float:right;"
            href="javascript:location.href='https://ra.publicca.hinet.net/SSLQueryCert/SSLQueryCert.jsp?Domain_name='+document.location.hostname"
          >
            <img
              src="../../../public/img/SSLSeal.gif"
              width="90"
              height="125"
              alt="ePKI憑證"
            />
          </a>
          <a
            href="mailto:nukipay@nuk.edu.tw?subject=意見反映信箱："
            aria-label="發送意見反映電子郵件"
          >
            意見反映信箱
          </a>
          <br />本網站所蒐集有關教職員生個人資訊，僅供教育行政使用，不另做其他用途。
          <br />最佳瀏覽建議使用Chrome、Firefox、Edge、Safari等瀏覽器。版本{{
            Version
          }}
        </div>
      </div>
      <!--END row-->
    </footer>
  </div>
</template>

<script>
export default {
  data () {
    return {
      Version: window.g.Version
    }
  }
}
</script>
